export const environment = {
    production: false,
    sw: false,
    version: '1.0.0',
    serverUrl: 'https://api.stelmach.sandbox.cloud.codelabs.work/',
    defaultLanguage: 'pl',
    supportedLanguages: ['pl', 'en', 'de', 'sk'],
    mapCoordinates: {
        latitude: 50.6794376,
        longitude: 17.9008646,
        accuracy: 20,
        altitude: null,
        altitudeAccuracy: null,
        heading: null,
        speed: null,
        mapTypeId: 'roadmap',
    },
    imageResolutions: {
        s: 480,
        m: 1280,
        l: 1920,
    },
    metrixUrl: 'https://stelmach.metrix-demo.com/',
    appUrl: 'https://app.stelmach.sandbox.cloud.codelabs.work/',
};
